module.exports = __webpack_public_path__ + "img/br49.13623d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br49.jpg
// module id = 0oXM
// module chunks = 0